<template>
  <div :style="this.gradient_filter"></div>
</template>

<script>
export default {
  props: {
    rgbaColor: String
  },
  computed: {
    hex_from_rgba: function () {
      return this.$options.filters.rbgaToHex(this.rgbaColor)
    },
    gradient_filter: function () {
      return {
        background: `-moz-linear-gradient(45deg, ${this.rgbaColor} 0%, rgba(0,0,0,0) 100%)`, // eslint-disable-line no-dupe-keys
        background: `-webkit-linear-gradient(45deg, ${this.rgbaColor} 0%,rgba(0,0,0,0) 100%)`, // eslint-disable-line no-dupe-keys
        background: `linear-gradient(45deg, ${this.rgbaColor} 0%,${this.rgbaColor} 50%, rgba(0,0,0,0) 100%)`, // eslint-disable-line no-dupe-keys
        filter: `progid:DXImageTransform.Microsoft.gradient( startColorstr='${this.hex_from_rgba}', endColorstr='#000000',GradientType=1 )`
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
